import React from 'react';

const NoLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <>{children}</>; 
};

export default NoLayout;